import { useCallback, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

/**
 * PATCH : une mise à jour PARTIELLE, seuls les champs envoyés changent (11/10/2026 : la correction d'une
 * variante de l'évaluation nationale, qui garde son item et son établissement). Même contrat que
 * usePutApi : doPatch(donnees, adresse) rend { success: true, data } ou { success: false, error }.
 */
export const usePatchApi = () => {
  const [isLoading, setIsLoading] = useState(false);

  const doPatch = useCallback(async (donnees, adresse) => {
    setIsLoading(true);
    const headers = { 'X-CSRFToken': Cookies.get('csrftoken') };
    if (!(donnees instanceof FormData)) headers['Content-Type'] = 'application/json';
    try {
      const resultat = await axios.patch(adresse, donnees, { headers, withCredentials: true });
      return { success: true, data: resultat.data };
    } catch (error) {
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  }, []);

  return [{ isLoading }, doPatch];
};
